import { formatDate } from '@avantstay/backoffice-core'

import { SearchCaseRowProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'

export interface DueDatePeriodProps {
  start: string | Date
  end: string | Date
}

const DATE_RANGE_SEPARATOR = '_'

export const formatDateRange = (value?: DueDatePeriodProps | null): string => {
  if (!value) {
    return ''
  }

  const rangeFields = [value.start, value.end]

  return rangeFields.join(DATE_RANGE_SEPARATOR)
}

export const parseDates = (value: string): DueDatePeriodProps | undefined => {
  if (!value) {
    return undefined
  }
  const [startDate, checkOut] = value.split(DATE_RANGE_SEPARATOR)
  return {
    start: formatDate(startDate),
    end: formatDate(checkOut),
  }
}

const closedAndCancelledStatuses = [
  'Cancelled',
  'Closed',
  'Completed CX Escalation',
  'Completed - Review',
  'Skipped',
  'Clean Complete - Send HK Back',
  'Clean Complete - Review',
  'Closed - Missed',
]

export const getCaseCount = (cases?: SearchCaseRowProps[]) => {
  if (cases) {
    return {
      active: cases.filter(currentCase => !closedAndCancelledStatuses.includes(currentCase.status))
        .length,
      completed: cases.filter(currentCase =>
        closedAndCancelledStatuses.includes(currentCase.status),
      ).length,
    }
  }

  return { active: 0, completed: 0 }
}
